import { Autocomplete } from "@avenue-8/sidekick-ui";
import { TextField } from "@shared/components/TextField";
import { COUNTRIES, Country } from "@shared/utils/countries";

type CountrySelectProps = {
  label?: string;
  name?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  fieldError?: { message?: string };
};

export const CountrySelect = (props: CountrySelectProps) => {
  const { label, name, value, onChange, onBlur, fieldError } = props;

  const selected = COUNTRIES.find(
    (country) => country.code === value.toUpperCase(),
  );

  return (
    <Autocomplete
      fullWidth
      disableClearable
      autoHighlight
      options={COUNTRIES}
      value={selected}
      onChange={(_, option: Country) => onChange(option.code)}
      onBlur={onBlur}
      getOptionLabel={(option) => option.name}
      getOptionKey={(option) => option.code}
      isOptionEqualToValue={(option, selectedOption) =>
        option.code === selectedOption.code
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          name={name}
          fieldError={fieldError}
        />
      )}
    />
  );
};
